var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BackTop',{attrs:{"duration":300}},[_c('div',{staticClass:"o-top"},[_c('Icon',{attrs:{"type":"ios-arrow-up"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }